import React, { useRef } from "react";

import "./JobCard.scss";
export default ({
  jobDetail,
  onJobCardClick,
  activeJobCard,
  jobCardDivParentRef,
}) => {
  const scrollToCardRef = useRef(null);

  if (activeJobCard) {
    if (scrollToCardRef?.current) {
      let topPos =
        scrollToCardRef?.current && scrollToCardRef.current?.offsetTop;
      jobCardDivParentRef.current.scrollTo({ top: topPos, behavior: "smooth" });
    }
  }
  return (
    <div
      className={`job-box  px-4 mb-3 ${activeJobCard ? "active" : ""}`}
      onClick={() => onJobCardClick(jobDetail?.id)}
      ref={scrollToCardRef}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex justify-content-between flex-grow-1">
          <div className="company-img">
            <img
              src={
                jobDetail?.posted_by_details &&
                  jobDetail.posted_by_details?.company_details &&
                  jobDetail.posted_by_details.company_details?.logo === null
                  ? "/assets/images/building-placeholder.png"
                  : jobDetail?.posted_by_details &&
                  jobDetail.posted_by_details?.company_details &&
                  jobDetail.posted_by_details.company_details?.logo
              }
              alt="company logo"
              className="border-radius-10 mr-3"
            />
          </div>
          <div className="flex-grow-1">
            <h3 className="text-dark text-capitalize mb-1">{jobDetail?.title}</h3>
            <p className="text-grey-4 mb-1">
              {jobDetail?.posted_by_details &&
                jobDetail.posted_by_details?.company_details &&
                jobDetail.posted_by_details.company_details?.name}
            </p>
            <span className="text-capitalize text-grey-4">
              {jobDetail?.state_name},{" "}
              {jobDetail?.country_name}
            </span>
          </div>
        </div>
      </div>

      <ul className="d-flex tags my-3 flex-wrap  text-capitalize">
        <li className="mx-1 text-dark rounded-pill bg-grey-4 border px-2 py-1 mr-2 mt-2 ">
          {jobDetail?.employment_type &&
            jobDetail.employment_type?.replace(/_/g, " ")}
        </li>
        <li className="text-dark rounded-pill bg-grey-4 border px-2 py-1 mr-2 mt-2">
          {jobDetail?.experience && jobDetail.experience?.replace(/_/g, " ")}
        </li>
        <li className="text-dark rounded-pill bg-grey-4 border px-2 py-1 mr-2 mt-2 ">
          {jobDetail?.job_function}
        </li>
      </ul>
    </div>
  );
};
